import { render, staticRenderFns } from "./LsSettings.vue?vue&type=template&id=86a26f78&scoped=true&"
import script from "./LsSettings.vue?vue&type=script&lang=js&"
export * from "./LsSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86a26f78",
  null
  
)

export default component.exports